import { LOGO_URL, BRAND } from "../lib/brand";

const CORPORATE_URL = "https://cfcorporatesolutions.com";

export default function BrandLogo({ size = "md", showText = true, className = "" }) {
  const dimensions = {
    sm: "h-10",
    md: "h-14",
    lg: "h-20",
    xl: "h-28",
  }[size] || "h-14";

  return (
    <a
      href={CORPORATE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="brand-logo-link"
      className={`flex items-center gap-3 ${className} hover:opacity-90 transition-opacity`}
      title="Visit cfcorporatesolutions.com"
    >
      <img
        src={LOGO_URL}
        alt={`${BRAND.name} logo`}
        className={`${dimensions} w-auto object-contain`}
        loading="eager"
        data-testid="brand-logo"
      />
      {showText && (
        <div className="leading-tight">
          <div className="font-display text-lg sm:text-xl font-bold" data-testid="brand-name">{BRAND.short}</div>
          <div className="text-[10px] sm:text-[11px] text-[var(--muted-text)] uppercase tracking-wider">Course Dashboard</div>
        </div>
      )}
    </a>
  );
}

// Wide banner variant — full natural-aspect logo, no frame so the brand reads cleanly.
export function BrandBanner({ className = "" }) {
  return (
    <a
      href={CORPORATE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="brand-banner-link"
      className={`inline-block hover:opacity-90 transition-opacity ${className}`}
      title="Visit cfcorporatesolutions.com"
    >
      <img
        src={LOGO_URL}
        alt={`${BRAND.name} logo`}
        className="w-full max-w-md h-auto object-contain"
        loading="eager"
        data-testid="brand-banner"
      />
    </a>
  );
}
